import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getNotificationEventChannelDetails } from 'services/admin';

import type { ChannelDetails, ChannelEventDetails } from '../types';

export const useGetNotificationEventChannelDetails = ({
  isEmployeeNotificationSettings,
  enabledFeatures,
}: {
  isEmployeeNotificationSettings?: boolean;
  enabledFeatures: string[];
}) =>
  useQuery<{
    channelDetailsArray: ChannelDetails[];
    channelEventDetailsArray: ChannelEventDetails[];
  }>({
    queryKey: [
      REACT_QUERY_KEYS.settings.notificationEventChannelDetails,
      isEmployeeNotificationSettings,
      enabledFeatures,
    ] as const,
    queryFn: () => getNotificationEventChannelDetails({ isEmployeeNotificationSettings, enabledFeatures }),
  });
